/** Sarah Walker AI conversations + Track A user AI chat browser. */
export default [

  {
    path: '/ai/conversations',
    name: 'AI Chats',
    component: () => import('@/views/private/AiConversationsView.vue'),
    meta: {
      public: false,
      title: 'AI Chats',
    },
  },

  {
    path: '/ai/conversations/:conversationId',
    name: 'AI Chat',
    component: () => import('@/views/private/AiConversationView.vue'),
    props: function(route) {
      return {
        conversationId: Number(route.params.conversationId),
      };
    },
    meta: {
      public: false,
      title: 'AI Chat',
    },
  },

  {
    path: '/ai/llm-requests',
    name: 'AI Requests Queue',
    component: () => import('@/views/private/AiLlmRequestsView.vue'),
    meta: {
      public: false,
      title: 'AI Requests Queue',
    },
  },

  {
    path: '/ai/message-feedback',
    name: 'Webwalker AI Feedback',
    component: () => import('@/views/private/WebwalkerAiMessageFeedbackView.vue'),
    meta: {
      public: false,
      title: 'Webwalker AI Feedback',
    },
  },

  {
    path: '/sarah-walker/conversations',
    name: 'Sarah Walker Conversations',
    component: () => import('@/views/private/SarahWalkerConversationsView.vue'),
    meta: {
      public: false,
      title: 'Sarah Walker - Conversations',
    },
  },

  {
    path: '/sarah-walker/conversations/:conversationId',
    name: 'Sarah Walker [conversation]',
    component: () => import('@/views/private/SarahWalkerConversationsView.vue'),
    props: function(route) {
      return {
        conversationId: Number(route.params.conversationId),
      };
    },
    meta: {
      public: false,
      title: 'Sarah Walker - Conversation',
    },
  },

  {
    path: '/sarah-walker/message-feedback',
    name: 'Sarah Walker Feedback',
    component: () => import('@/views/private/SarahWalkerMessageFeedbackView.vue'),
    meta: {
      public: false,
      title: 'Sarah Walker Feedback',
    },
  },

];
